import { Drawer, Input, Modal } from "antd";
import React from "react";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateInterview } from "../../../../../../redux/actions";
import "./interviewStatusCard.css";

export function ShareDetails({
  interviewId,
  openModal,
  setOpenShareInterview,
  onConfirmInterview,
  bidType,
}) {
  const dispatch = useDispatch();
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [interviewLink, setInterviewLink] = useState();
  const [interviewLocation, setInterviewLocation] = useState("");
  const [isValid, setIsValid] = useState(true);

  const closeModal = () => {
    setOpenShareInterview(false);
  };
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  // function validURL(myURL) {
  //     var pattern = new RegExp('^(https?:\/\/)?'+ // protocol
  //     '((([a-z\d]([a-z\d-]*[a-z\d])*)\.?)+[a-z]{2,}|'+ // domain name
  //     '((\d{1,3}\.){3}\d{1,3}))'+ // ip (v4) address
  //     '(\:\d+)?(\/[-a-z\d%_.~+]*)*'+ //port
  //     '(\?[;&amp;a-z\d%_.~+=-]*)?'+ // query string
  //     '(\#[-a-z\d_]*)?$','i');
  //     return pattern.test(myURL);
  //  }

  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch (error) {
      return false;
    }
  };

  const requestSend = () => {
    setIsValid(isValidUrl(interviewLink));
    const InterviewType =
      interviewLink.length != 0
        ? "Online"
        : interviewLocation.length != 0
        ? "Onsite"
        : "";

    if (isValidUrl(interviewLink) || !!interviewLocation) {
        setIsValid(!isValid)
      if (InterviewType == "Online") {
        onConfirmInterview()
        dispatch(
          updateInterview({
            InterviewId: interviewId,
            InterviewType: InterviewType,
            MeetingURL: interviewLink,
            InterviewStatus: "Scheduled",
            bidType,
            loading: 'share-details'
          })
        );
      } else if (InterviewType == "Onsite") {
        onConfirmInterview()
        dispatch(
          updateInterview({
            InterviewId: interviewId,
            InterviewType: InterviewType,
            MeetingURL: "",
            Location: interviewLocation,
            InterviewStatus: "Scheduled",
            loading: 'share-details',
            bidType,
          })
        );
      } else {
        setOpenShareInterview(false);
        return;
      }

      setOpenShareInterview(false);
    }
  };

  return (
    <div>
      {windowDimensions.width > 768 ? (
        <Modal
          onCancel={closeModal}
          visible={openModal}
          title={<strong>Confirm Interview Details</strong>}
          footer={
            <div className="modal-footer-div">
              <button onClick={requestSend}>Confirm interview</button>
            </div>
          }
          centered
          width={400}
        >
          <h3>Interview link (Zoom, Teams, Meet, etc.,)</h3>
          <Input
            type="text"
            value={interviewLink}
            onChange={(e) => {
              setInterviewLink(e.target.value);
              setInterviewLocation("");
            }}
            placeholder="Paste the meeting link here"
            disabled={interviewLocation?.length > 0}
          />
          {(!isValid) && (
            <p
              style={{
                color: "red",
                fontSize: "15px",
                fontWeight: "600",
                marginBottom: "0px",
                textAlign: "center",
                marginTop: "5px",
              }}
            >
              Please paste a valid link here
            </p>
          )}
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginTop: "3%",
              marginBottom: "3%",
            }}
          >
            <strong>Or</strong>
          </div>
          <h3>Interview location</h3>
          <Input
            type="text"
            value={interviewLocation}
            onChange={(e) => {
              setInterviewLocation(e.target.value);
              setInterviewLink("");
            }}
            placeholder="Add the address of where the interview will be held..."
            disabled={interviewLink?.length > 0}
          />
        </Modal>
      ) : (
        <Drawer
          title={<strong>Confirm Interview Details</strong>}
          onClose={closeModal}
          visible={openModal}
          placement="top"
          zIndex={20000}
          height={360}
        >
          <h3>Interview link (Zoom, Teams, Meet, etc.,)</h3>
          <Input
            type="text"
            value={interviewLink}
            onChange={(e) => {
              setInterviewLink(e.target.value);
              setInterviewLocation("");
            }}
            placeholder="Add the meeting link..."
            disabled={interviewLocation?.length > 0}
          />
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginTop: "3%",
              marginBottom: "3%",
            }}
          >
            <strong>Or</strong>
          </div>

          <h3>Interview location</h3>
          <Input
            type="text"
            value={interviewLocation}
            onChange={(e) => {
              setInterviewLocation(e.target.value);
              setInterviewLink("");
            }}
            placeholder="Add the address of where the interview will be held..."
            disabled={interviewLink?.length > 0}
          />
          <div className="modal-footer-div" style={{ marginTop: "5%" }}>
            <button onClick={requestSend}>Confirm interview</button>
          </div>
        </Drawer>
      )}
    </div>
  );
}
